import gql from 'graphql-tag'
import { EnumFields } from '..'

export const StreetTypeFragment = gql`
  fragment StreetType on persons_street_type {
    ${EnumFields}
  }
`
